/**
 * TokenPopover数据处理Hook的常量定义
 */

import type { AssetType, TokenQueryParams, StockQueryParams } from "./types";

// 支持的资产类型
export const SUPPORTED_ASSET_TYPES: readonly AssetType[] = [
  "token",
  "stock",
  "pool",
] as const;

// 默认显示值
export const DEFAULT_VALUES = {
  PRICE_FALLBACK: "—",
  PERCENTAGE_FALLBACK: "-",
  EMPTY_CHART_DATA: [],
} as const;

// 数字格式化精度
export const DECIMAL_PRECISION = {
  HIGH_PRICE: 2, // 大于等于1的价格保留2位小数
  LOW_PRICE: 6, // 小于1的价格保留6位小数
  PERCENTAGE: 2, // 百分比保留2位小数
} as const;

// 价格阈值
export const PRICE_THRESHOLDS = {
  HIGH_PRECISION: 1, // 大于等于此值使用高精度格式
} as const;

// 时间配置
export const TIME_CONFIG = {
  CHART_DAYS_RANGE: 7, // 图表数据天数范围
  OHLC_INTERVAL: "1h", // OHLC数据间隔
  STOCK_PERIOD: "365d", // 股票数据周期
} as const;

// Token/Pool查询参数模板
export const TOKEN_QUERY_PARAMS: Omit<
  TokenQueryParams,
  "enrich.with_ohlc.start_time" | "enrich.with_ohlc.end_time"
> = {
  "enrich.enable": true,
  "enrich.with_market.enable": true,
  "enrich.with_ticker": true,
  "enrich.with_rating": true,
  "enrich.with_ohlc.enable": true,
  "enrich.with_ohlc.interval": TIME_CONFIG.OHLC_INTERVAL,
} as const;

// Stock查询参数模板
export const STOCK_QUERY_PARAMS: StockQueryParams = {
  "enrich.enable": true,
  "enrich.with_trading_data": true,
  "enrich.with_ohlcv.enable": true,
  "enrich.with_recommendation_trend": true,
  "enrich.with_target_price": true,
  "enrich.with_ohlcv.period": TIME_CONFIG.STOCK_PERIOD,
  "enrich.with_rating": true,
} as const;

// 错误消息
export const ERROR_MESSAGES = {
  UNSUPPORTED_TYPE: "Unsupported asset type",
  INVALID_CARD_ITEM: "Invalid card item provided",
  API_FETCH_ERROR: "Failed to fetch data from API",
  DATA_FORMAT_ERROR: "Invalid data format received",
  MISSING_REQUIRED_FIELD: "Missing required field in data",
} as const;

// 调试日志前缀
export const LOG_PREFIX = "[TokenPopoverData]" as const;
